import React from 'react';
import Header from '../Integration/Header';
import FbDetailsGetService from '../../Middleware/Firebase/FbDetailsGetService';
import FooterMenu from '../Integration/FooterMenu';

function PageDetailsService() {
  return (
    <div>
    <Header />
    <FbDetailsGetService/>
    <FooterMenu/>
    </div>
  );
}

export default PageDetailsService;
